import React, { useState, useContext } from 'react';
import {
    Toolbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Grid,
    Fab,
    Typography,
    Button,
    Chip
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import { grey, red, green } from '@material-ui/core/colors';

import SideMenu from '../../components/SideMenu';
import InputSearch from '../../components/InputSearch'
import Alert from '../../components/Alert';
import Popup from '../../components/Popup';

import api from '../../services/api';
import { PermissionsContext } from '../../providers/Permissions';
import { ListPageHeading, ListTableCard, listResultSubtitle } from '../../components/ListPageLayout';

export default function NotificationList() {
    const classes = useStyles();

    const {
        PermissionWrapper,
        PermissionOneOfWrapper,
    } = useContext(PermissionsContext);

    const [notifications, setNotifications] = useState(null);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [refresh, setRefresh] = useState(true)
    const [limit, setLimit] = useState(10);

    const [openDeletePopup, setOpenDeletePopup] = useState(false);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const [isDeleting, setIsDeleting] = useState(false);
    const [deletingNotification, setDeletingNotification] = useState();
    const handleDelete = (id) => {
        setDeletingNotification(id);
        setOpenDeletePopup(true);
    };


    const deleteNotification = async () => {
        try {
            setIsDeleting(true);

            const result = await api.delete(`/notification/delete/${deletingNotification}`);

            const { notification } = result.data;

            setIsDeleting(false);

            if (notification) {
                setDeletingNotification(null);
                setOpenDeletePopup(false);
                setRefresh(!refresh);
                setMessage({
                    open: true,
                    variant: 'success',
                    text: `Notificação "${notification.name}" deletada com sucesso!`,
                });
            }
        } catch (err) {
            setIsDeleting(false);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    function updateRequest({ search }) {
        const loadData = async () => {
            try {
                const result = await api.get('/notification/list', {
                    params: {
                        search,
                        limit,
                        page,
                    },
                });

                const { count, notifications } = result.data;

                setNotifications(notifications);
                setTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        };

        loadData();
    }

    const changePage = (_, newPage) => {
        setPage(newPage);
    };

    const quantityPerPage = ({ target }) => {
        setLimit(parseInt(target.value, 10));
        setPage(0);
    };

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="notification" title="Lista de Notificações" />
                    </Grid>

                    <Grid item xs={12}>
                        <ListTableCard
                            title="Notificações cadastradas"
                            subtitle={listResultSubtitle(total)}
                            actions={(
                                <InputSearch
                                    textFieldProps={{
                                        placeholder: 'Buscar…',
                                    }}
                                    request={updateRequest}
                                    pagination={[page, limit, refresh]}
                                    className={classes.inputSearch}
                                />
                            )}
                        >
                            <TableContainer component={Paper} elevation={6} className={classes.paper}>
                                <Table className={classes.table} size="small" aria-label="access history">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead}>ID</TableCell>
                                            <TableCell className={classes.tableHead}>Name</TableCell>
                                            <TableCell className={classes.tableHead}>Status</TableCell>
                                            <TableCell className={classes.tableHead}>Descrição</TableCell>
                                            <TableCell className={classes.tableHead}>Whatsapp</TableCell>
                                            <TableCell className={classes.tableHead}>Email</TableCell>
                                            <TableCell className={classes.tableHead}>Pop-up</TableCell>
                                            <PermissionOneOfWrapper
                                                routes={[
                                                    "/notificação/modificar/:id",
                                                    "/notificação/deletar/:id",
                                                ]}
                                            >
                                                <TableCell className={classes.tableHead}>Ações</TableCell>
                                            </PermissionOneOfWrapper>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!!notifications && notifications.map(notification => (
                                            <TableRow key={notification.id}>
                                                <TableCell className={classes.tableBody} component="th" scope="row">
                                                    {notification.id}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {notification.name}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {notification?.active === true ? (
                                                        <Chip
                                                            label="Ativada"
                                                            className={classes.enabledNotification}
                                                            size="small"
                                                        />
                                                    ) : (
                                                        <Chip
                                                            label="Desativada"
                                                            className={classes.disabledNotification}
                                                            size="small"
                                                        />
                                                    )}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {notification.description ? notification.description : ''}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {notification.whatsapp ? "Habilitado" : "Não Habilidado"}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {notification.email ? "Habilitado" : "Não Habilidado"}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {notification.pop_up ? "Habilitado" : "Não Habilidado"}
                                                </TableCell>
                                                <PermissionOneOfWrapper
                                                    routes={[
                                                        "/notificação/modificar/:id",
                                                        "/notificação/deletar/:id",
                                                    ]}
                                                >
                                                    <TableCell className={classes.tableBody}>
                                                        <PermissionWrapper route="/notificação/modificar/:id">
                                                            <Button
                                                                type="button"
                                                                variant="contained"
                                                                size="small"
                                                                color="primary"
                                                                className={classes.actionButton}
                                                                href={`/notificação/modificar/${notification.id}`}
                                                            >
                                                                <EditIcon style={{ fontSize: 20 }} />
                                                            </Button>
                                                        </PermissionWrapper>
                                                        <PermissionWrapper route="/notificação/deletar/:id">
                                                            <Button
                                                                type="button"
                                                                variant="contained"
                                                                size="small"
                                                                color="secondary"
                                                                className={classes.actionButton}
                                                                onClick={() => handleDelete(notification.id)}
                                                            >
                                                                <DeleteIcon style={{ fontSize: 20 }} />
                                                            </Button>
                                                        </PermissionWrapper>
                                                    </TableCell>
                                                </PermissionOneOfWrapper>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ListTableCard>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={total}
                            rowsPerPage={limit}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={changePage}
                            onChangeRowsPerPage={quantityPerPage}
                        />
                    </Grid>
                    <Popup
                        openPopup={openDeletePopup}
                        setOpenPopup={setOpenDeletePopup}

                    >
                        <Grid container xs={12} style={{
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '0 3% 2% 3%',

                        }}>
                            <Typography variant='h5'
                                style={{
                                    fontWeight: 'bold',
                                    color: '#9e9e9e'
                                }}
                            >
                                Deseja mesmo deletar essa notificação ?
                            </Typography>
                            <Grid item style={{
                                marginTop: '50px'
                            }}>
                                <Button
                                    disabled={isDeleting}
                                    variant="contained"
                                    onClick={() => deleteNotification()}
                                    color="secondary"
                                    endIcon={<DeleteIcon />}
                                >
                                    {isDeleting ? 'Deletando...' : 'Sim, delete a notificação'}
                                </Button>
                            </Grid>

                        </Grid>
                    </Popup>
                </Grid>
                <PermissionWrapper route="/notificação/criar">
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={classes.fabButton}
                        href="/notificação/criar"
                    >
                        <AddIcon />
                    </Fab>
                </PermissionWrapper>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}

            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
    title: {
        color: 'rgba(6, 19, 31, 1)',
        fontSize: 28,
        fontWeight: 600,
    },
    inputSearch: {
        width: 340,
        maxWidth: '100%',
        '& .MuiTextField-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 40,
            borderRadius: 20,
            backgroundColor: '#f9fafb',
            transition: 'background-color 160ms ease, box-shadow 160ms ease',
            '&:hover': {
                backgroundColor: '#fff',
            },
            '&.Mui-focused': {
                backgroundColor: '#fff',
                boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.10)',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#dfe3e8',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    paper: {
        borderRadius: 12,
        backgroundColor: '#fff',
    },
    table: {
        minWidth: 500,
        width: '100%',
    },
    tableHead: {
        borderBottom: '1px solid #e5e7eb',
        fontWeight: 700,
        textAlign: 'center',
        padding: '14px 10px',
        textTransform: 'uppercase',
        backgroundColor: '#f8fafc',
        color: '#64748b',
        letterSpacing: '0.06em',
        fontSize: 11,
        position: 'sticky',
        top: 0,
    },
    tableBody: {
        color: '#374151',
        padding: '14px 10px',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '1px solid #eef1f5',
    },
    actionButton: {
        margin: theme.spacing(0, .5),
        padding: theme.spacing(.5, 0),
        minWidth: 30,
        borderRadius: 9,
    },
    fabButton: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: theme.spacing(3),
    },
    enabledNotification: {
        height: 26,
        color: '#16794b',
        backgroundColor: '#e8f7ef',
        fontWeight: 600,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    disabledNotification: {
        height: 26,
        color: '#b91c1c',
        backgroundColor: '#fef2f2',
        fontWeight: 600,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
}));
